module.exports = __webpack_public_path__ + "img/u62.ae06d01.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/clay/u62.png
// module id = aSad
// module chunks = 0